module.exports = __webpack_public_path__ + "img/img_47@2x.539881f9.png";